import { query_customer_list } from '@/api/mjstore-model';
import { reactive } from 'vue';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import defaultSlotList from '@/components/page-model/slotList';
import { TableColumn } from '@/typing';
import { SearchConfig } from '@/components/FormRender/RemoteModal/typing';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const config: SearchConfig = {
  settings: {
    name: '表单名称',
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'input',
      name: 'search_text',
      label: '模糊查询',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写会员姓名',
    },
    {
      type: 'input',
      name: 'name',
      label: '会员姓名',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写会员姓名',
    },
    {
      type: 'input',
      name: 'phone',
      label: '手机',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写手机',
    },
    {
      type: 'remoteselect',
      name: 'shop_id',
      label: '会籍',
      disabled: false,
      placeholder: '请选择会籍',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-shop',
    },
    {
      type: 'input',
      name: 'code',
      label: '会员编号',
      disabled: false,
      allowClear: true,
      inputType: 'text',
      defaultValue: '',
      placeholder: '请填写会员编号',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    name: null,
    search_text: null,
    phone: null,
    shop_id: null,
    code: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const columns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
    slots: { customRender: 'index' },
  },
  {
    title: '客户ID',
    width: 150,
    dataIndex: 'id',
    fixed: false,
    checked: false,
  },
  {
    title: '会员编号',
    width: 150,
    dataIndex: 'code',
    fixed: false,
    checked: true,
  },
  {
    title: '会员姓名',
    width: 150,
    dataIndex: 'name',
    fixed: false,
    checked: true,
  },
  {
    title: '等级名称',
    width: 150,
    dataIndex: 'grade__name',
    fixed: false,
    checked: true,
  },
  {
    title: '建档日期',
    width: 150,
    dataIndex: 'join_date',
    fixed: false,
    checked: true,
  },
  {
    title: '性别',
    width: 150,
    dataIndex: 'gender',
    slots: { customRender: 'gender' },
    fixed: false,
    checked: true,
  },
  {
    title: '出生日期',
    width: 150,
    dataIndex: 'birthday',
    fixed: false,
    checked: true,
  },
  {
    title: '手机',
    width: 150,
    dataIndex: 'phone',
    fixed: false,
    checked: true,
  },
  {
    title: '会籍',
    width: 150,
    dataIndex: 'shop_id',
    fixed: false,
    checked: false,
  },
  {
    title: '会籍门店',
    width: 150,
    dataIndex: 'shop__name',
    fixed: false,
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    fixed: false,
    checked: true,
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    fixed: false,
    checked: true,
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    fixed: false,
    checked: true,
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, defaultSlotList);
newSlotList.push(
  {
    type: 'custom',
    slotName: 'gender',
    field_0: '女',
    field_1: '男',
  },
  {
    type: 'custom',
    slotName: 'is_active',
    field_true: '可用',
    field_false: '禁用',
  },
);
export default () => {
  return {
    searchConfig: config,
    searchConfigOptions: search_options,
    getData: query_customer_list,
    columns: columns,
    slotList: newSlotList,
  };
};
